import axios from 'axios';

import { getCurrentUserAccount } from '../api/user/getCurrentUserAccount';
import { AUTH_TOKEN_COOKIE_NAME } from '../config/auth';
import { deleteCookie, getCookie } from '../lib/cookies';

export function getCurrentUserQueryKey(url?: string) {
  return ['current-user', url];
}

export function currentUserQuery(url?: string) {
  return {
    queryKey: getCurrentUserQueryKey(url),
    queryFn: async () => {
      const token = getCookie(AUTH_TOKEN_COOKIE_NAME);

      if (!token) {
        return null;
      }

      try {
        const response = await getCurrentUserAccount(token);

        return response.data.data;

      } catch (error) {
        deleteCookie(AUTH_TOKEN_COOKIE_NAME, { path: '/' });
        if (axios.isAxiosError(error) && error.response?.status === 401) {
          return null;
        }

        throw error;
      }
    },
    staleTime: Number.POSITIVE_INFINITY,
  };
}
